module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** SitePage Dvd1 Free Tour */

(function (fox) {
  "use strict";

  fox.registerWidget(
    "Account_Settings",
    {
      configure: function (options) {
        this.registerOptions("", {
          widgets: {
            dataApi: {
              widget: "Api",
              method: "site.authorizer.changePassword",
            },
          },

          fieldsSelector: ".field2send",
          messageBlockSelector: "#notice-success",
          phrases: {
            empty: "Field shouldn't be empty",
            oldPassEmpty: "Old Password can't be empty",
            newPassEmpty: "New Password can't be empty",
            cNewPassEmpty: "Confirm New Password can't be empty",
            notMatch: "New and confirmed passwords do not match",
            oldPassIncorrect: "Incorrect Password",
            success: "Password was successfully changed",
            newPassShort: "Password must contain at least six characters",
          },

          template: "account_settings",
          container: ".general-settings",
          autoRender: true,

          "handleWom.onResponse": {
            widget: "#dataApi",
            event: "success",
            callback: "@this:onResponse",
          },

          handlers: {
            submit: {
              target: "#submit",
              event: "click",
              callback: "submit",
            },
            blurHandler: {
              target: ".field2send",
              event: "blur",
              callback: "_check",
            },
          },
        });

        this.validationStates = {
          oldPassword: false,
          newPassword: false,
          confirmNewPassword: false,
        };

        this.callParent("configure", arguments);
      },

      rendering: function () {
        this.callParent("rendering", arguments);

        this.fields = fox.dom.select(
          this.getOption("fieldsSelector"),
          this.fragment
        );
        this.messageBlock = fox.dom.select(
          this.getOption("messageBlockSelector"),
          this.fragment
        );
      },

      _check: function (field) {
        switch (field.name) {
          case "oldPassword":
            this.validationStates[field.name] = !this._isEmpty(
              field,
              this.getOption("phrases.oldPassEmpty")
            );
            break;

          case "newPassword":
            var isEmpty = this._isEmpty(
              field,
              this.getOption("phrases.newPassEmpty")
            );
            var minLength = this._isMinLength(
              field,
              this.getOption("phrases.newPassShort")
            );
            if (!isEmpty && !minLength) {
              var confirm = fox.dom.selectFirst(
                '[name="confirmNewPassword"]',
                this.element
              );

              if (confirm.value !== "") {
                this.validationStates[field.name] = this._isMatch(
                  field,
                  confirm,
                  this.getOption("phrases.notMatch")
                );
              }
              if (confirm.value !== "") {
                this.validationStates[field.name] = this._isMatch(
                  field,
                  confirm,
                  this.getOption("phrases.notMatch")
                );
              }
            } else {
              this.validationStates[field.name] = !isEmpty;
            }
            break;

          case "confirmNewPassword":
            var isEmpty = this._isEmpty(
              field,
              this.getOption("phrases.cNewPassEmpty")
            );
            if (!isEmpty) {
              var newPassword = fox.dom.selectFirst(
                '[name="newPassword"]',
                this.element
              );

              if (newPassword.value !== "") {
                this.validationStates[field.name] = this._isMatch(
                  newPassword,
                  field,
                  this.getOption("phrases.notMatch")
                );
              }
            } else {
              this.validationStates[field.name] = !isEmpty;
            }
            break;
        }
      },

      checkFields: function () {
        var result = true;

        fox.each(
          this.fields,
          function (field) {
            this._check(field);
          },
          this
        );

        for (var key in this.validationStates) {
          if (!this.validationStates[key]) {
            result = false;
          }
        }

        return result;
      },

      _isEmpty: function (elem, phrase) {
        var notice = fox.dom.selectFirst("#notice-" + elem.name, this.element);
        if (!elem.value.length) {
          notice.style.display = "block";
          notice.innerHTML = phrase;
          return true;
        } else {
          notice.style.display = "none";
          notice.innerHTML = "";
          return false;
        }
      },

      _isMinLength: function (elem, phrase) {
        var notice = fox.dom.selectFirst("#notice-" + elem.name, this.element);
        if (elem.value.length < 6) {
          notice.style.display = "block";
          notice.innerHTML = phrase;
          return true;
        } else {
          notice.style.display = "none";
          notice.innerHTML = "";
          return false;
        }
      },

      _isMatch: function (elem1, elem2, phrase) {
        var notice = fox.dom.selectFirst("#notice-" + elem1.name, this.element),
          string1 = new String(fox.trim(elem1.value)),
          string2 = new String(fox.trim(elem2.value));

        if (string1.toString() != string2.toString()) {
          notice.style.display = "block";
          notice.innerHTML = phrase;
          return false;
        } else {
          notice.style.display = "none";
          notice.innerHTML = "";
          return true;
        }
      },

      submit: function (el, alias, e) {
        this.toggleSuccessBlock(false);

        var arr = {};
        if (this.checkFields()) {
          fox.each(
            this.fields,
            function (field) {
              arr[field.name] = fox.trim(field.value);
            },
            this
          );
          this.rwom1("#dataApi").send(arr);
        }
      },

      onResponse: function (response) {
        if (response.answer.response.success) {
          this.hookWrapper("changeSuccess", response);
        } else {
          this.hookWrapper("changeFailure", response);
        }
      },

      toggleSuccessBlock: function (flag, message) {
        if (!this.messageBlock) {
          return;
        }

        if (flag) {
          $(this.messageBlock).css("display", "inline-block");
        } else {
          $(this.messageBlock).css("display", "none");
        }

        this.messageBlock.innerHTML = message || "";
      },

      changeSuccess: function () {
        this.toggleSuccessBlock(true, this.getOption("phrases.success"));
      },

      changeFailure: function (data) {
        var error = data.answer.response.error;

        switch (error) {
          case "oldPassword":
            var notice = fox.dom.selectFirst(
              "#notice-oldPassword",
              this.element
            );
            notice.style.display = "block";
            notice.innerHTML = this.getOption("phrases.oldPassIncorrect");
            break;
          case "match":
            var notice = fox.dom.selectFirst(
              "#notice-newPassword",
              this.element
            );
            notice.style.display = "block";
            notice.innerHTML = this.getOption("phrases.notMatch");
            break;
        }
      },
    },
    "Site_Page"
  );
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/account/settings.js
// module id = 796
// module chunks = 4